import { SWITCH_TO_PAGE } from "./actionTypes";
import initialState from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SWITCH_TO_PAGE:
      return {
        ...state,
        path: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
